import { createContext } from 'react'
import { TFileManagerContext } from './types'

export const ImagesContext = createContext<TFileManagerContext | undefined>(undefined)